// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3lwHI","resendInfoText":"OnGoingPaymentBox_resendInfoText__3P4VT"};